import React from 'react'
import SidebarAudience from './SidebarAudience/SidebarAudience'
import {
    SidebarAudiencesViewProps,
} from './types'
import {styled} from 'stitches/config'
import {styledGroup} from 'components/Sidebar/styles'
import {useTranslation} from 'react-i18next'

const StyledGroup = styled('ul', styledGroup)

const SidebarAudiencesView = ({
    audiences, nested, isGroupQueue,
}: SidebarAudiencesViewProps): React.ReactElement => {
    const {t} = useTranslation()

    return (
        <>
            {audiences?.length > 0 &&
                <StyledGroup aria-label={t('Audiences')} nested={nested}>
                    {
                        audiences.map((audienceChannelId) => <SidebarAudience channel_id={audienceChannelId} isGroupQueue={isGroupQueue} key={audienceChannelId} nested={nested} />)
                    }
                </StyledGroup>}
            {}
        </>
    )
}
export default SidebarAudiencesView
